export const Position = {
    '临床协调员I': '临床协调员I',
    '临床协调员II': '临床协调员II',
};

export const WorkStatus = {
    WORKING: '在职',
    LEFT: '离职',
};

export const Default = {
    0: '否',
    1: '是'
};


// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/constants.js